import React from 'react'
import { createIcon } from '~/chakra'

export const DeviceMobileIcon = createIcon({
  displayName: 'DeviceMobileIcon',
  viewBox: '0 0 15 23',
  path: (
    <>
      <path
        d="M8.21197 2.34619H5.8658c-.32372 0-.5865.26279-.5865.58656 0 .32377.26278.58656.58655.58656h2.34618c.32377 0 .58655-.26279.58655-.58656 0-.32377-.26284-.58656-.58661-.58656Z"
        fill="currentColor"
      />
      <path
        d="M11.1442 0H2.93267C1.31619 0 0 1.31619 0 2.93267V19.3558c0 1.6165 1.31619 2.9326 2.93267 2.9326h8.21153c1.6165 0 2.9327-1.3161 2.9327-2.9326V2.93267C14.0769 1.31619 12.7607 0 11.1442 0ZM7.03846 20.5288c-.64638 0-1.17306-.5267-1.17306-1.173 0-.6464.52673-1.1731 1.17306-1.1731.64639 0 1.17306.5267 1.17306 1.1731 0 .6463-.52667 1.173-1.17306 1.173Zm5.86544-4.1058H1.17306V2.93267c0-.97015.78946-1.75961 1.75961-1.75961h8.21153c.9701 0 1.7596.78946 1.7596 1.75961V16.423h.0001Z"
        fill="currentColor"
      />
    </>
  ),
})
